"use client";

import React, { useState } from "react";
import Image from "next/image";
import Link from "next/link";

import { Media } from "../../../_components/Media";
import { Price } from "../../../_components/Price";
import { RemoveFromCartButton } from "../../../_components/RemoveFromCartButton";

import classes from "./index.module.scss";

const CartItemQuickAdd = ({
  product,
  title,
  metaImage,
  qty,
  variation,
  addItemToCart,
}) => {
  const [quantity, setQuantity] = useState(qty);

  const decrementQty = () => {
    const updatedQty = quantity > 1 ? quantity - 1 : 1;

    setQuantity(updatedQty);
    addItemToCart({ product, quantity: Number(updatedQty) });
  };

  const incrementQty = () => {
    const updatedQty = quantity + 1;

    setQuantity(updatedQty);
    addItemToCart({ product, quantity: Number(updatedQty) });
  };

  const enterQty = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedQty = Number(e.target.value);

    setQuantity(updatedQty);
    addItemToCart({ product, quantity: Number(updatedQty) });
  };

  let hasVariant = variation && typeof variation === "object" && !Array.isArray(variation) && Object.keys(variation).length > 0;
  const imageToDisplay = hasVariant ? variation?.variationGallery?.[0].image : metaImage;

  return (
    <tr>
      <td className={classes.td}>
        <Link
          href={`/products/${product.slug}`}
          className={classes.mediaWrapper}
        >
          {!imageToDisplay && <span>No image</span>}
          {imageToDisplay && typeof imageToDisplay !== "string" && (
            <Image
              className={classes.media}
              src={imageToDisplay.url}
              width={70}
              height={70}
              alt={title}
            />
          )}
        </Link>
        {/*<div>{title}</div>*/}
      </td>
      <td className={classes.td}>
        <div className={classes.itemDetails}>
          <div className={classes.quantity}>
            <div className={classes.quantityBtn} onClick={decrementQty}>
              <Image
                src="/assets/icons/minus.svg"
                alt="minus"
                width={14}
                height={14}
                className={classes.qtnBt}
              />
            </div>

            <input
              type="text"
              className={classes.quantityInput}
              value={quantity}
              onChange={enterQty}
            />

            <div className={classes.quantityBtn} onClick={incrementQty}>
              <Image
                src="/assets/icons/plus.svg"
                alt="plus"
                width={14}
                height={14}
                className={classes.qtnBt}
              />
            </div>
          </div>
        </div>
        {/*<RemoveFromCartButton product={product} />*/}
      </td>
      <td className={classes.td}>
        <div className={classes.subtotalWrapper}>
          <Price product={product} button={false} quantity={quantity} />
          {/*<RemoveFromCartButton product={product} />*/}
        </div>
      </td>
      <td className={classes.td}>
        <RemoveFromCartButton product={product} icon={true} />
      </td>
    </tr>
  );
};

export default CartItemQuickAdd;
